// extracted by mini-css-extract-plugin
module.exports = {"Card":"style_Card__20VI6","Btn":"style_Btn__2qc9d","Marck":"style_Marck__1w3wU","Wrapper":"style_Wrapper__2uUhm","Content":"style_Content__3N2n1","Avatar":"style_Avatar__1h_jx"};